export default {
  isAuthorized: (state) => !!state.profile,
  userId: ({ profile }, getters) => {
    if (getters.isAuthorized) {
      return profile.id;
    }
    return null;
  },
  fio: ({ profile }, getters) => {
    if (!getters.isAuthorized) {
      return '';
    }
    const { first_name, patro_name, last_name } = profile;
    return [last_name, first_name, patro_name]
      .filter((item) => String(item).length)
      .join(' ');
  },
};



// WEBPACK FOOTER //
// ./src/store/user/getters.js